import type { ReactNode } from 'react'
import { ScrollArea } from '~/components/ui/scroll-area'
import { Separator } from '~/components/ui/separator'

/** Lien de retour à la liste, en tête du panneau : son `from` est typé par la route appelante. */
export const DETAIL_BACK_LINK_CLASS =
  'flex shrink-0 items-center justify-center rounded-xl bg-sidebar p-2 text-primary-600'

/**
 * Pied fixé en bas du panneau sur un fondu, comme la maquette. `-bottom-4` : le collage se cale
 * sur la marge intérieure du panneau (`p-4`), le bloc en reprend la hauteur pour toucher le bord.
 * Le fondu laisse passer les clics vers le contenu qu'il recouvre.
 */
export const DETAIL_PANEL_FOOTER_CLASS =
  'pointer-events-none sticky -bottom-4 z-10 -mx-4 -mb-4 mt-auto flex flex-col bg-linear-to-b from-transparent to-background-100 to-40% px-4 pt-8 pb-4 [&>*]:pointer-events-auto'

interface DetailPanelFrameProps {
  /** Lien de retour à la liste (`DETAIL_BACK_LINK_CLASS`). */
  back: ReactNode
  title: string
  /** Étiquettes à droite du titre (plaque, statut). */
  badges?: ReactNode
  children?: ReactNode
}

/**
 * Panneau gauche d'un détail posé sur la carte, simulation (#854) ou tournée en vigueur (#891) :
 * en-tête (retour, titre, étiquettes) puis contenu défilant.
 */
export function DetailPanelFrame({ back, title, badges, children }: DetailPanelFrameProps) {
  return (
    <ScrollArea
      className="rounded-2xl border border-black/6 bg-background-100 shadow-lg"
      containerClassName="flex flex-col gap-8 p-4"
    >
      <div className="flex flex-col gap-4">
        <div className="flex items-center gap-3">
          {back}
          <h2 className="flex-1 truncate font-brand text-lg leading-5 font-semibold text-primary-600">
            {title}
          </h2>
          {badges}
        </div>
        <Separator className="bg-black/6" />
      </div>
      {children}
    </ScrollArea>
  )
}
